enum ECDSA {
  ed25519 = 'ed25519',
  secp256k1 = 'ecdsa-secp256k1',
}

export default ECDSA
